import gql from 'graphql-tag';

export const GET_SETTINGS_BY_SCOPE = gql`
  query ($scope: String!, $scopeId: ID = null){
    settingsFetchByScope(scope: $scope, scope_id: $scopeId) {
      id
      scope
      scope_id
      data_filled
      data_scoped
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/settings/fetchScope.js